/**
 * Store для управления уведомлениями (Notifications)
 *
 * Описание: Хранилище состояния для раздела управления уведомлениями в CRM
 *
 * Алгоритм работы:
 * 1. Хранит список уведомлений из таблицы data_notification_instances
 * 2. Управляет состоянием загрузки и ошибками
 * 3. Хранит параметры пагинации, сортировки и поиска
 *
 * Текущий ход разработки:
 * - Создана базовая структура store
 * - Добавлены поля для фильтрации по всем параметрам таблицы
 */

import { atom } from "recoil";

export const notificationsStore = atom({
	key: "notificationsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		filters: {
			active: null,
			priority: null,
			dateFrom: null,
			dateTo: null,
			localName: "",
			titleType: "",
			descriptionType: "",
		},
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
		queue: {
			loaded: false,
			data: [],
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
			currentSearch: "",
			currentDateRange: null,
			sorting: {
				sortingColumn: {
					order: "DESC",
					column: "sendDate",
				},
				isDescending: true,
			},
			pagination: {
				current: 1,
				total: 0,
				count: 0,
			},
		},
	},
});
